import { OpenSearchTableFilterType, OpenSearchTableFilter } from '@interfaces/models';
import { Button } from '@ui/components/button/button';
import { useTranslation } from 'react-i18next';
import { Delete } from '@ui/components/icons';
import { cn } from '@ui/utils';
import React from 'react';

import { DynamicFilterMultiSelect, DynamicFilterInput } from './dynamic-filter-components';
import { DynamicFiltersState } from './use-dynamic-filters';

interface TransactionHistoryTableFiltersProps extends React.ComponentPropsWithoutRef<'div'> {
  filters: OpenSearchTableFilter[];
  filtersState: DynamicFiltersState;
  onSelectChange: (id: string, value: string) => void;
  onMultiSelectChange: (id: string, values: string[]) => void;
  onInputChange: (id: string, value: string) => void;
  onClear: () => void;
}

export const DynamicFilters = ({
  filtersState,
  filters,
  onMultiSelectChange,
  onInputChange,
  onClear,
}: TransactionHistoryTableFiltersProps) => {
  const { t } = useTranslation();

  if (!filters) {
    return null;
  }

  return (
    <div className="flex items-center gap-4 p-4">
      <div className={cn('grid grid-cols-4 xl:grid-cols-6 gap-4 w-full')}>
        {filters.map((filter) => {
          switch (filter.filterType) {
            case OpenSearchTableFilterType.MULTI_SELECT: {
              const selectOptions = filter.availableOptions?.map((option) => ({
                label: t(option.value),
                value: option.id,
              }));

              return (
                <DynamicFilterMultiSelect
                  onChange={(value) => onMultiSelectChange(filter.id, value)}
                  placeholder={t(`DYNAMIC_FILTERS.${filter.id}`)}
                  values={filtersState[filter.id] as string[]}
                  options={selectOptions || []}
                  key={filter.id}
                />
              );
            }
            case OpenSearchTableFilterType.NUMBER_INPUT:
            case OpenSearchTableFilterType.TEXT_INPUT: {
              return (
                <DynamicFilterInput
                  type={
                    filter.filterType === OpenSearchTableFilterType.NUMBER_INPUT ? 'number' : 'text'
                  }
                  onChange={(value) => onInputChange(filter.id, value)}
                  placeholder={t(`DYNAMIC_FILTERS.${filter.id}`)}
                  value={filtersState[filter.id] as string}
                  name={filter.id}
                  key={filter.id}
                />
              );
            }
            //   case OpenSearchTableFilterTypeEnum.SELECT: {
            //     const selectOptions = filter.availableOptions?.map((option) => ({
            //       label: t(option.value),
            //       value: option.id,
            //     }));

            //     return (
            //       <DynamicFilterSelect
            //         onChange={(value) => onSelectChange(filter.id, value)}
            //         value={filtersState[filter.id] as string}
            //         options={selectOptions || []}
            //         placeholder={filter.id}
            //         name={filter.id}
            //         key={filter.id}
            //       />
            //     );
            //   }
          }
        })}
      </div>
      <Button variant="tertiary" onClick={onClear} size="small">
        <Delete />
      </Button>
    </div>
  );
};
